import * as React from "react";
import PropTypes from "prop-types"

import * as styles from "./PageInfo.module.scss";

const PageInfo = ({ text }) => (
  <section className={styles.root}>
    <div className={styles.container}>
      <span className={styles.text}>{text}</span>
    </div>
  </section>
);

PageInfo.propTypes = {
  text: PropTypes.string.isRequired
};

export default PageInfo;